export const cookies = [
    'functional-cookies',
    'analytical-cookies',
    'video-cookies',
    'tracking-cookies'
];
export const requiredCookies = [
    'functional-cookies',
    'analytical-cookies'
];
